import { ApiLambdalerAuthHeaderSchema } from '@eigtech/lambdaler-api-gateway-types';
import { z } from 'zod';
import { MeetingDetailsSchema } from '../base/meetingDetails.js';
export const GetActiveMeetingsApiSchema = {
    headers: ApiLambdalerAuthHeaderSchema,
    response: z.array(MeetingDetailsSchema.omit({ chimeEvents: true })),
};
export const GetActiveMeetingsRequestSchema = GetActiveMeetingsApiSchema.headers;
